import React, { useEffect } from "react";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import { compose } from "redux";
import SmartRender from "containers/SmartRender";
import styles from "./styles";
import { createStructuredSelector } from "reselect";
import {
  fetchNumbers,
  numberLock,
  setData,
  changeFormField
} from "ducks/actions";
import {
  makeSelectAvailableNumbers,
  makeSelectSelectedNumber,
  makeSelectFormattedOldNumber,
  makeSelectOldPhoneNumber,
  makeSelectNumberChangeDates,
  makeSelectChangeNumberInitialValues,
  makeSelectChangeNumberForm,
  makeSelectPageValidations,
  makeSelectChangeNumberFeeTotalPrice
} from "ducks/selectors";
import { forms } from "utils/constants";
import get from "lodash/get";
import validate from "validations";
import isEmpty from "lodash/isEmpty";
import isFunction from "lodash/isFunction";

const RequestNumberChange = Component =>
  function Comp(props) {
    const {
      changeField,
      fetchNumbers,
      selectedNumber,
      availableNumbers
    } = props;

    useEffect(() => {
      changeField("oldNumber", get(props, "orderDetails.phone_number"));

      if (isEmpty(availableNumbers) && isFunction(fetchNumbers)) {
        fetchNumbers();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      changeField("selectedNumber", selectedNumber);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedNumber]);

    return <Component {...props} />;
  };

const mapStateToProps = createStructuredSelector({
  formValues: makeSelectChangeNumberForm(),
  formValidations: makeSelectPageValidations(forms.CHANGE_NUMBER_FORM),
  availableNumbers: makeSelectAvailableNumbers(),
  selectedNumber: makeSelectSelectedNumber(),
  formattedSelectedNumber: makeSelectFormattedOldNumber(),
  oldPhoneNumber: makeSelectOldPhoneNumber(),
  availableDates: makeSelectNumberChangeDates(),
  styles: () => styles,
  initialValues: makeSelectChangeNumberInitialValues(),
  numberChangeFees: makeSelectChangeNumberFeeTotalPrice()
});

export function mapDispatchToProps(dispatch) {
  return {
    validateAndNavigateToConfirmation: (navigate, payload) => {
      navigate(payload);
    },
    selectNumber: number => {
      dispatch(setData({ key: "numbers", data: { error: null } }));
      dispatch(numberLock({ number }));
    },

    changeField: (field, value) => {
      dispatch(
        changeFormField({
          form: forms.CHANGE_NUMBER_FORM,
          field: field,
          value: value
        })
      );
    },
    fetchNumbers: () => {
      dispatch(fetchNumbers());
    },
    selectDate: value => {
      dispatch(
        setData({ key: "orderDetails", data: { selected_date: value } })
      );
      dispatch(
        changeFormField({
          form: forms.CHANGE_NUMBER_FORM,
          field: "scheduled_date",
          value: value
        })
      );
    }
  };
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  messageData: {
    numberChangeFees: stateProps.numberChangeFees
  }
});

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export default compose(
  withConnect,
  reduxForm({
    form: forms.CHANGE_NUMBER_FORM,
    validate: validate,
    destroyOnUnmount: false
  })
)(RequestNumberChange(SmartRender));
